export default "__VITE_ASSET__6cf27f7c__"